<template>
  <ba-dialog
    :save="save"
    :title="$t('_connectCoinbase')"
    :canSave="!canSave"
    :show-button="false"
    :show="showDialog"
    :onHide="hideDialog"
  >
    <v-container fluid grid-list-xl>
      <v-layout wrap align-center>
        <v-flex xs6 sm6 md6>
          <p>
            We recommend that the API credentials you are sharing with us be
            <b>read-only</b>.
          </p>
          <v-text-field label="API Key" v-model="apiKey"></v-text-field>
          <v-text-field label="API Secret" v-model="apiSecret"></v-text-field>
          <v-text-field label="API Passphrase" v-model="apiPassphrase"></v-text-field>
          <v-autocomplete
            v-model="exchangeContactId"
            :items="contacts"
            :label="$t('_exchangeContact')"
            item-text="name"
            item-value="id"
            persistent-hint
          ></v-autocomplete>
          <!-- <v-checkbox label="Is Coinbase Exchange" v-model="isPrime"></v-checkbox> -->
        </v-flex>
      </v-layout>
    </v-container>
  </ba-dialog>
</template>

<script>
import gql from 'graphql-tag';
export default {
  props: ['refresh'],
  data() {
    return {
      apiKey: '',
      apiSecret: '',
      apiPassphrase: '',
      showDialog: false,
      exchangeContactId: '',
      isPrime: true,
    };
  },
  computed: {
    canSave() {
      return this.apiKey && this.apiSecret && this.apiPassphrase && this.exchangeContactId;
    },
    contacts() {
      return this.$store.getters['contacts/ENABLED_CONTACTS'];
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.apiKey = '';
      this.apiSecret = '';
      this.apiPassphrase = '';
      this.exchangeContactId = '';
      this.isPrime = true;
    },
    hideDialog() {
      this.showDialog = false;
    },
    show() {
      this.showDialog = true;
    },
    save() {
      const vars = {
        orgId: this.$store.state.currentOrg.id,
        create: {
          createCoinbasePro: {
            apiKey: this.apiKey,
            apiSecret: this.apiSecret,
            apiPassphrase: this.apiPassphrase,
            exchangeContactId: this.exchangeContactId,
            isPrime: this.isPrime,
          },
        },
      };
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation CreateConnection($orgId: ID!, $create: CreateConnectionInput!) {
              createConnection(orgId: $orgId, create: $create) {
                success
                errors
                message
              }
            }
          `,
          // Parameters
          variables: vars,
        })
        .then(() => {
          this.resetForm();
          if (this.refresh) {
            this.refresh();
          }
          this.showDialog = false;
        });
    },
  },
};
</script>
